import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faChartPie,
    faMapMarkerAlt,
    faPhoneAlt,
    faEnvelope,
} from '@fortawesome/free-solid-svg-icons';
import {
    faLinkedin,
    faTwitter,
    faFacebookF,
    faInstagram,
} from '@fortawesome/free-brands-svg-icons';
import { HashLink } from 'react-router-hash-link'; // ✅ new import
import './Footer.css';

const servicesLinks = [
    { title: 'Corporate Tax', href: '/corporatetax' },
    { title: 'Tax Agents', href: '/taxagents' },
    { title: 'Accounting & Bookkeeping', href: '/bookkeeping' },
    { title: 'VAT & Tax Compliance', href: '/vatconsult' },
    { title: 'Audit & Assurance', href: '/audit' },
    { title: 'Internal Audit', href: '/internalaudit' },
];

const quickLinks = [
    { title: 'About Us', href: '/#about' },
    { title: 'Services', href: '/#services' },
    { title: 'Contact Us', href: '/#contact' },
    { title: 'Testimonial', href: '/#testimonials' },
];

const Footer = () => {
    return (
        <footer className="footer-section text-white py-5">
            <div className="container">
                <div className="row">
                    {/* Left Info */}
                    <div className="col-lg-4 mb-4 mb-lg-0">
                        <h5 className="fw-bold text-white mb-3">
                            <FontAwesomeIcon icon={faChartPie} className="me-2 text-primary-custom" />
                            Emkan Financial Services
                        </h5>
                        <p className="text-white-50 mb-4">
                            Your trusted partner for comprehensive accounting, bookkeeping, and financial services in the UAE. We provide clarity, compliance, and confidence to help your business grow.
                        </p>
                        <div className="d-flex gap-3">
                            <a href="#" className="text-white-50">
                                <FontAwesomeIcon icon={faLinkedin} className="fs-4" />
                            </a>
                            <a href="#" className="text-white-50">
                                <FontAwesomeIcon icon={faTwitter} className="fs-4" />
                            </a>
                            <a href="https://www.facebook.com/EmkanAccounting/" className="text-white-50">
                                <FontAwesomeIcon icon={faFacebookF} className="fs-4" />
                            </a>
                            <a href="https://www.instagram.com/emkan_accounting/" className="text-white-50">
                                <FontAwesomeIcon icon={faInstagram} className="fs-4" />
                            </a>
                        </div>
                    </div>

                    {/* Services Links */}
                    <div className="col-lg-2 col-md-4 mb-4 mb-lg-0">
                        <h5 className="text-white mb-3">Our Services</h5>
                        <ul className="list-unstyled">
                            {servicesLinks.map((link, index) => (
                                <li className="mb-2" key={index}>
                                    <a href={link.href} className="text-white-50 text-decoration-none">
                                        {link.title}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Quick Links */}
                    <div className="col-lg-2 col-md-4 mb-4 mb-lg-0">
                        <h5 className="text-white mb-3">Quick Links</h5>
                        <ul className="list-unstyled">
                            {quickLinks.map((link, index) => (
                                <li className="mb-2" key={index}>
                                    <HashLink
                                        smooth
                                        to={link.href}
                                        className="text-white-50 text-decoration-none"
                                    >
                                        {link.title}
                                    </HashLink>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div className="col-lg-4 col-md-4">
                        <h5 className="text-white mb-3">Contact Us</h5>
                        <ul className="list-unstyled">
                            <li className="mb-2 text-white-50">
                                <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2 text-primary-custom" />
                                Al Huda Building 208, al murar Deira Dubai, UAE
                            </li>
                            <li className="mb-2 text-white-50">
                                <FontAwesomeIcon icon={faPhoneAlt} className="me-2 text-primary-custom" />
                                +971 4 123 4567
                            </li>
                            <li className="mb-2 text-white-50">
                                <FontAwesomeIcon icon={faEnvelope} className="me-2 text-primary-custom" />
                                gcctax@emkanaccounting.com
                            </li>
                        </ul>
                    </div>
                </div>

                <hr className="my-4 border-secondary" />

                <div className="row align-items-center">
                    <div className="col-md-6 text-center text-md-start">
                        <p className="mb-0 text-white-50">
                            &copy; 2024 Emkan. All rights reserved.
                        </p>
                    </div>
                    <div className="col-md-6 text-center text-md-end mt-3 mt-md-0">
                        <a href="#" className="text-decoration-none text-white-50 me-3">
                            Terms of Service
                        </a>
                        <a href="#" className="text-decoration-none text-white-50">
                            Privacy Policy
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
